import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { types } from 'mobx-state-tree';
import { ConfigurationSchema } from '@jbrowse/core/configuration';
// Note: this is primarily a copy of createBaseTrackConfig, except with a
// subset of the config slots, to avoid including fields that don't make sense
// for the ReferenceSequenceTrack
/**
 * #config ReferenceSequenceTrack
 * used to display base level DNA sequence tracks
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
export function createReferenceSeqTrackConfig(pluginManager) {
  return ConfigurationSchema('ReferenceSequenceTrack', {
    /**
     * #slot
     * configuration for track adapter
     */
    adapter: pluginManager.pluggableConfigSchemaType('adapter'),
    /**
     * #slot
     * configuration for the displays e.g. LinearReferenceSequenceDisplay
     */
    displays: types.array(pluginManager.pluggableConfigSchemaType('display')),
    /**
     * #slot
     */
    name: {
      type: 'string',
      description: 'optional track name, otherwise uses the "Reference sequence (assemblyName)"',
      defaultValue: ''
    },
    /**
     * #slot
     */
    metadata: {
      type: 'frozen',
      description: 'anything to add about this track',
      defaultValue: {}
    },
    formatAbout: ConfigurationSchema('FormatAbout', {
      /**
       * #slot formatAbout.config
       */
      config: {
        type: 'frozen',
        description: 'formats configuration in about dialog',
        defaultValue: {},
        contextVariable: ['config']
      },
      /**
       * #slot formatAbout.hideUris
       */
      hideUris: {
        type: 'boolean',
        defaultValue: false
      }
    })
  }, {
    preProcessSnapshot: function preProcessSnapshot(s) {
      var snap = JSON.parse(JSON.stringify(s));
      var displayTypes = new Set();
      var _snap$displays = snap.displays,
        displays = _snap$displays === void 0 ? [] : _snap$displays;
      if (snap.trackId !== 'placeholderId') {
        // Gets the displays on the track snapshot and the possible displays
        // from the track type and adds any missing possible displays to the
        // snapshot
        displays.forEach(function (d) {
          return d && displayTypes.add(d.type);
        });
        var trackType = pluginManager.getTrackType(snap.type);
        trackType.displayTypes.forEach(function (displayType) {
          if (!displayTypes.has(displayType.name)) {
            displays.push({
              displayId: "".concat(snap.trackId, "-").concat(displayType.name),
              type: displayType.name
            });
          }
        });
      }
      return _objectSpread({}, snap, {
        displays: displays
      });
    },
    /**
     * #identifier
     * all tracks have a globally unique 'trackId'
     */
    explicitIdentifier: 'trackId',
    explicitlyTyped: true,
    actions: function actions(self) {
      return {
        addDisplayConf: function addDisplayConf(displayConf) {
          var type = displayConf.type;
          if (!type) {
            throw new Error("unknown display type ".concat(type));
          }
          var display = self.displays.find(function (d) {
            return d && d.displayId === displayConf.displayId;
          });
          if (display) {
            return display;
          }
          var length = self.displays.push(displayConf);
          return self.displays[length - 1];
        }
      };
    }
  });
}